import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import {
  IInvoice,
  IInvoiceCreatePayload,
  IInvoiceUpdatePayload,
  IInvoiceStatusPayload,
  IInvoicePaymentPayload,
  IInvoiceDeletePayload,
  IInvoiceFromQuotePayload,
  IInvoiceStats,
} from "../../../types/api/invoice";

export async function listInvoices(
  qData: QData,
): Promise<AxiosResponse<TResponseWithQData<IInvoice[]>>> {
  return axios.get(API_ENDPOINTS.INVOICE_LIST, { params: qData });
}

export async function invoiceDetail(
  id: string | number,
): Promise<AxiosResponse<TResponse<IInvoice>>> {
  return axios.get(`${API_ENDPOINTS.INVOICE_DETAIL}/${id}`);
}

export async function invoiceStats(): Promise<
  AxiosResponse<TResponse<IInvoiceStats>>
> {
  return axios.get(API_ENDPOINTS.INVOICE_STATS);
}

export async function createInvoice(
  data: IInvoiceCreatePayload,
): Promise<AxiosResponse<TResponse<IInvoice>>> {
  return axios.post<TResponse<IInvoice>>(API_ENDPOINTS.INVOICE_CREATE, data);
}

export async function updateInvoice(
  data: IInvoiceUpdatePayload,
): Promise<AxiosResponse<TResponse<IInvoice>>> {
  return axios.post<TResponse<IInvoice>>(API_ENDPOINTS.INVOICE_UPDATE, data);
}

export async function deleteInvoice(
  data: IInvoiceDeletePayload,
): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.INVOICE_DELETE, data);
}

export async function updateInvoiceStatus(
  data: IInvoiceStatusPayload,
): Promise<AxiosResponse<TResponse<IInvoice>>> {
  return axios.post<TResponse<IInvoice>>(API_ENDPOINTS.INVOICE_STATUS, data);
}

export async function recordInvoicePayment(
  data: IInvoicePaymentPayload,
): Promise<AxiosResponse<TResponse<IInvoice>>> {
  return axios.post<TResponse<IInvoice>>(API_ENDPOINTS.INVOICE_PAYMENT, data);
}

export async function createInvoiceFromQuote(
  data: IInvoiceFromQuotePayload,
): Promise<AxiosResponse<TResponse<IInvoice>>> {
  return axios.post<TResponse<IInvoice>>(API_ENDPOINTS.INVOICE_FROM_QUOTE, data);
}

export async function createInvoiceFromPO(
  data: { po_id: number; title?: string; issue_date?: string; due_date?: string },
): Promise<AxiosResponse<TResponse<IInvoice>>> {
  return axios.post<TResponse<IInvoice>>(API_ENDPOINTS.INVOICE_FROM_PO, data);
}

export function getInvoicePdfUrl(id: number): string {
  return `${API_ENDPOINTS.INVOICE_PDF}/${id}`;
}

export async function createCreditNote(
  data: { original_invoice_id: number; reason?: string; line_items?: any[] },
): Promise<AxiosResponse<TResponse<IInvoice>>> {
  return axios.post<TResponse<IInvoice>>(API_ENDPOINTS.INVOICE_CREDIT_NOTE, data);
}

export async function generateInvoiceShareLink(
  id: number,
): Promise<AxiosResponse<TResponse<{ token: string }>>> {
  return axios.post<TResponse<{ token: string }>>(
    `${API_ENDPOINTS.INVOICE_SHARE}/${id}/share`,
  );
}
